import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/20/solid'
import { classNames } from '~/utils/client/helpers'

export type AlertBannerType = 'error' | 'warning' | 'info' | 'success'

export type AlertBannerProps = {
  type?: AlertBannerType
  title: string
  children?: React.ReactNode
  className?: string
} & React.ComponentProps<'div'>

export default function AlertBanner({
  type = 'error',
  title,
  children,
  className,
  ...props
}: AlertBannerProps) {
  const bannerColor =
    type === 'info'
      ? 'bg-blue-50'
      : type === 'warning'
      ? 'bg-yellow-50'
      : type === 'error'
      ? 'bg-red-50'
      : 'bg-green-50'

  const titleColor =
    type === 'info'
      ? 'text-blue-800'
      : type === 'warning'
      ? 'text-yellow-800'
      : type === 'error'
      ? 'text-red-800'
      : 'text-green-800'

  const textColor =
    type === 'info'
      ? 'text-blue-700'
      : type === 'warning'
      ? 'text-yellow-700'
      : type === 'error'
      ? 'text-red-700'
      : 'text-green-700'

  const Icon =
    type === 'success'
      ? CheckCircleIcon
      : type === 'warning'
      ? ExclamationTriangleIcon
      : type === 'info'
      ? InformationCircleIcon
      : XCircleIcon

  return (
    <div className={classNames('rounded-md p-4 text-start', bannerColor, className)} {...props}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={classNames('h-5 w-5', textColor)} aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className={classNames('text-sm font-semibold', titleColor)}>{title}</h3>
          {children && <div className={classNames('mt-2 text-sm', textColor)}>{children}</div>}
        </div>
      </div>
    </div>
  )
}
